
export default {
//    USER_POOL_ID: "eu-central-1_svkQQTQcU",
//    CLIENT_ID: "2lmqr3srjl9gil58q2njii1i1g",
    USER_POOL_ID: "eu-central-1_cNGXQMl41",
    CLIENT_ID: "5rdg9utfe5j4gp8c8a916qb9rf",
    REACT_APP_ENDPOINT: "https://cognito-idp.eu-central-1.amazonaws.com"
};
